<template>
<img class="article-style-image" :src="widgetConfig.ImageUrl" :class="{ 'has-mobile-side-padding': widgetConfig.IncludePadding }" alt="" />
</template>

<script>
export default {
    name: "ArticleStyleImage",
    props: {
        widgetConfig: Object,
    }
}
</script>

<style lang="scss" scoped>
.article-style-image {
    display: block;
    margin: auto;
    width: 100%;
    margin-top: $spacer-six;

    @include tablet {
        max-width: $narrower-page-width-padded;
        padding: 0 $page-padding;
    }

    @include wide-mobile {
        width: 100%;

        &.has-mobile-side-padding {
            padding: 0 $page-padding;
        }
    }
}
</style>
